var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeautify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.964,
    height: 10,
    viewBox: "0 0 14.964 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17954",
    "data-name": "Group 17954",
    transform: "translate(-1064.5 -189)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_537",
    "data-name": "Line 537",
    x2: 9.976,
    transform: "translate(1064.5 189.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_538",
    "data-name": "Line 538",
    x2: 9.976,
    transform: "translate(1064.5 198.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_539",
    "data-name": "Line 539",
    x2: 9.976,
    transform: "translate(1069.488 195.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_540",
    "data-name": "Line 540",
    x2: 9.976,
    transform: "translate(1069.488 192.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautify);
export default __webpack_public_path__ + "static/media/beautify.d3de08fab59f3bdfaf7e8673ea1e7310.svg";
export { ForwardRef as ReactComponent };